import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {connect} from 'react-redux';
import * as Actions from 'actions';
import moment from 'moment';
import { Tab, Nav, Row, Col, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import {
	InteractionsList, ClientDetails, ClientCustomDetails,
	ClientContacts, WidgetClientDamageIncidents, ClientModify,
	ClientTaskList, ClientPermissions
} from './';
import {
	FieldList, Tasks, LoadingSpinner
} from '../';

class ClientView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      key : 'RecentActivity'
    }
    this.handleSelect = this.handleSelect.bind(this);
  }
  componentWillMount() {
    this.props.fetchIncidents(this.props.client._id || this.props.client);
    if(localStorage) {
      this.setState({key : localStorage.getItem('client-view-key') || this.state.key });
    }
  }
  handleSelect(key) {
    this.setState({key});
    if(localStorage) {
      localStorage.setItem('client-view-key', key);
    }
  }
  render() {
    const {client, clients, user} = this.props;
    if(!this.props.client && !this.props.client._id) {
      return <div>No Client Loaded.</div>
    }
    const owners = client.owners;
    return (
      <div className="row">
				<div style={{position: 'fixed', zIndex: 1009, width: '100%', bottom: 0, left: 0}} className="">
					<div onClick={e => this.props.push('/clients/map')} className="btn btn-block btn-info"><i className="fa fa-arrow-left"></i> Back To Map</div>
				</div>
        <div className="col-xs-12 col-md-9 col-lg-9 animated fadeInDown">
           {(()=>{
            if(!client.owners || (!client.owners.find(({_id}) => _id == user._id) && client.owner._id != user._id && !user.parents.find(id => id == client.owner._id))) {
              return (
                <div className="alert alert-warning mb-sm">
                  <h3 className="mt-none">Warning!</h3>
                  <p>You do not own this client. Please contact {client.owner.name ? `${client.owner.name.first} ${client.owner.name.last}` : client.owner.username} {`(${client.owner.role})`} to be able to edit this client.</p>
                </div>
              );
            }
            return '';
          })()}
          <Tab.Container id="dashboard" activeKey={this.state.key} onSelect={this.handleSelect} >
            <Row className="clearfix">
              <Col sm={12}>
                <Nav bsStyle="tabs" onSelect={this.selectTab}>
                  <NavItem eventKey="RecentActivity">
                    <i className="fa fa-globe"></i> Recent Activity
                  </NavItem>
                  <NavItem eventKey="Details">
                    <i className="fa fa-info"></i> Details
                  </NavItem>
                  <NavItem eventKey="Modify">
                    <i className="fa fa-pencil"></i> Modify
                  </NavItem>
                  {/* <NavItem eventKey="Tasks">
                    <i className="fa fa-tasks"></i> Tasks
                  </NavItem> */}
                  <NavItem eventKey="Permissions">
                    <i className="fa fa-user"></i> Client Permissions
                  </NavItem>
                </Nav>
              </Col>
              <Col sm={12}>
                <Tab.Content animation>
									<Tab.Pane eventKey="RecentActivity">
										{clients.fetching_client ? <LoadingSpinner /> : (
											<div>
												<h2 className="pb-lg">Interactions</h2>
		                    <InteractionsList enableCreate/>
											</div>
										)}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Details">
										{clients.fetching_client ? <LoadingSpinner /> : <ClientCustomDetails />}
                  </Tab.Pane>
                  <Tab.Pane eventKey="Modify">
										{clients.fetching_client ? <LoadingSpinner /> : <ClientModify onSave={e => this.handleSelect('Details')} />}
                  </Tab.Pane>
                  {/* <Tab.Pane eventKey="Tasks">
										{clients.fetching_client ? <LoadingSpinner /> : (
											<div>
												<h2 className="pb-lg">Tasks</h2>
		                    <hr className="dotted short" />
		                    <div className='animated fadeInRight'>
			                    <Tasks
			                    	tasks={this.props.client.tasks}
			                    	client={this.props.client}
			                    />
		                    </div>
											</div>
										)}
                  </Tab.Pane> */}
                  <Tab.Pane eventKey="Permissions">
										{clients.fetching_client ? <LoadingSpinner /> : (
											<div>
												<h2 className="pb-lg">Client Permissions</h2>
		                    <div className='animated fadeInRight'>
			                    <ClientPermissions />
		                    </div>
											</div>
										)}
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
        <div className='col-xs-12 col-md-3 col-lg-3'>
          <WidgetClientDamageIncidents
          	onCreate={this.props.startCreateIncident}
          	client={this.props.client}
          	incidents={this.props.incidents}
          />
          <ClientContacts client={this.props.client} />
	      </div>
	    </div>
    );
  }
}

ClientView.propTypes = {
  client : PropTypes.object
}

const mapStateToProps = ({ connection, client , fields , client_incidents, clients }) => ({ user: connection.user, client , fields : fields.Client || [], incidents : client_incidents.incidents, clients });

export default connect(mapStateToProps, Actions)(ClientView);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-view.js